import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const ROTATING_WORDS = ["Skreddersydde", "Vi skaper"];

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ROTATING_WORDS.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="hjem" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/362e32b97_Verbier_vinter3.jpg"
          alt="LYKKE Premium badstue i snø – nordisk arkitektur og design"
          className="w-full h-full object-cover"
          width="1920"
          height="1080"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-black/10" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-32 md:pb-40 px-6 md:px-12 max-w-[1440px] mx-auto">
        <h1 className="font-heading text-white text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-light leading-[0.95] mb-6 animate-fade-up">
          <span className="inline-block min-h-[1em]">
            <AnimatePresence mode="wait">
              <motion.span
                key={index}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -12 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className="inline-block"
              >
                {ROTATING_WORDS[index]}
              </motion.span>
            </AnimatePresence>
          </span>
          <br />
          <span className="italic opacity-60">badstuer.</span>
        </h1>
        <p
          className="text-white/70 text-sm md:text-base tracking-widest-2xl font-body uppercase animate-fade-up"
          style={{ animationDelay: "0.3s" }}
        >
          Varme, ro og velvære, i Harmoni med naturen.
        </p>
      </div>

      <button
        onClick={() => {
          document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" });
        }}
        aria-label="Rull ned"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/50 hover:text-white transition-colors animate-bounce"
      >
        <ChevronDown size={28} strokeWidth={1} />
      </button>
    </section>
  );
}